import React from 'react';
import { Navigate } from 'react-router-dom';
// import _, { omit, pick, round, slice } from 'lodash';
import { useDispatch, useSelector } from "react-redux";





const PrivateRoute = ({ children }) => {
  const { UserInfo } = useSelector(state => ({
    UserInfo: state.app.UserInfo,
  }));

  return (UserInfo.PersonalId !== undefined || JSON.parse(localStorage.getItem("UserInfo"))?.PersonalId !== undefined ? children : <Navigate to="/" replace />
  )
}

export default PrivateRoute;